/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnicknames1Inputs */

const en_listingnicknames1 = /** @type {(inputs: Listingnicknames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do your guests call you?`)
};

const de_listingnicknames1 = /** @type {(inputs: Listingnicknames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie nennen euch eure Gäste?`)
};

/**
* | output |
* | --- |
* | "What do your guests call you?" |
*
* @param {Listingnicknames1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnicknames1 = /** @type {((inputs?: Listingnicknames1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnicknames1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnicknames1(inputs)
	return de_listingnicknames1(inputs)
});
export { listingnicknames1 as "listingNicknames" }